<div class="select-jobsite">
  <div class="select-jobsite__close" (click)="onCloseClick()">
    <span class="cmx-icon-close" aria-hidden="true"></span>
  </div>
  <div class="select-jobsite__title">
    {{ 'globalFilters.jobsites.modal.title' | translate }}
  </div>
  <div class="select-jobsite__line"></div>
  <div class="select-jobsite__form">
    <cwc-select
      [filterPlaceholder]="'globalFilters.jobsites.search' | translate"
      [placeholder]="'globalFilters.jobsites.placeholder' | translate"
      (cwcChange)="onSelect($event)"
      (cwcFilter)="onSearch($event)"
      [filterValue]="filter"
      [filter]="true"
      [attr.data-test]="'jobsite-search'"
      [attr.data-tid]="'jobsite-search'"
      [attr.data-name]="'jobsite-search'"
      [filterNoResultsMessage]="'globalFilters.jobsites.noResults' | translate"
      [rtl]="rtl$ | async"
      [height]="overlayHeight"
      [disabled]="loading"
      designVersion="v2"
    >
      <cwc-select-option
        *ngFor="let jobsite of jobsites | filterJobsites: filter; let i = index"
        [selected]="jobsite.id === selected"
        [value]="jobsite.id"
        [attr.data-test]="'jobsite-select-option'"
        [attr.data-tid]="'jobsite-select-option'"
        [attr.data-name]="'jobsite-select-option'"
        designVersion="v2"
      >
        {{ jobsite | formatJobsite }}
      </cwc-select-option>
    </cwc-select>
  </div>
  <div class="select-jobsite__buttons">
    <cwc-button [disabled]="isSubmitDisabled" [attr.data-test]="'jobsite-confirm-selection-btn'"
                (click)="!isSubmitDisabled && onSubmitClick()" designVersion="v2">
      {{ 'globalFilters.jobsites.modal.accept' | translate }}
    </cwc-button>
  </div>
</div>
